export default function GoogleIcon({
  className,
  colored = false,
}: {
  className?: string;
  colored?: boolean;
}) {
  if (colored) {
    return (
      <svg
        className={className}
        strokeWidth="0"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.72 7.15748C13.72 6.61498 13.664 6.09348 13.5695 5.59998H7V8.39998H10.7555C10.598 9.28548 10.1045 10.038 9.3555 10.5385V12.306H11.6305C12.9535 11.088 13.72 9.28898 13.72 7.15748Z"
          fill="#4285F4"
        />
        <path
          d="M6.99995 14C8.88995 14 10.472 13.3735 11.634 12.306L9.35895 10.5385C8.73245 10.955 7.93445 11.2 6.99995 11.2C5.18345 11.2 3.64344 9.97152 3.09744 8.31952H0.752441V10.1395C1.90044 12.4285 4.26294 14 6.99995 14Z"
          fill="#34A853"
        />
        <path
          d="M3.0975 8.31954C2.9575 7.90304 2.8805 7.45854 2.8805 7.00004C2.8805 6.54154 2.9575 6.09704 3.0975 5.68054V3.86053H0.752501C0.273 4.80554 0 5.86954 0 7.00004C0 8.13054 0.273 9.19454 0.749001 10.1395L3.0975 8.31954Z"
          fill="#FABB05"
        />
        <path
          d="M7.00003 2.8C8.02553 2.8 8.94253 3.1535 9.66703 3.843L11.683 1.827C10.472 0.693001 8.88653 0 7.00003 0C4.26303 0 1.90052 1.5715 0.749023 3.8605L3.09403 5.6805C3.64353 4.0285 5.18353 2.8 7.00003 2.8Z"
          fill="#E94235"
        />
      </svg>
    );
  }

  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      className={className}
      strokeWidth="0"
      viewBox="0 0 24 24"
      height="20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.06364 7.50914C4.70909 4.24092 8.09084 2 12 2C14.6954 2 16.959 2.99095 18.6909 4.60455L15.8227 7.47274C14.7864 6.48185 13.4681 5.97727 12 5.97727C9.39542 5.97727 7.19084 7.73637 6.40455 10.1C6.2045 10.7 6.09086 11.3409 6.09086 12C6.09086 12.6591 6.2045 13.3 6.40455 13.9C7.19084 16.2636 9.39542 18.0227 12 18.0227C13.3454 18.0227 14.4909 17.6682 15.3864 17.0682C16.4454 16.3591 17.15 15.3 17.3818 14.05H12V10.1818H21.4181C21.5364 10.8363 21.6 11.5182 21.6 12.2273C21.6 15.2727 20.5091 17.8363 18.6181 19.5773C16.9636 21.1046 14.7 22 12 22C8.09084 22 4.70909 19.7591 3.06364 16.4909C2.38638 15.1409 2 13.6136 2 12C2 10.3864 2.38638 8.85911 3.06364 7.50914Z"></path>
    </svg>
  );
}
